import { render, staticRenderFns } from "./FileShareView.vue?vue&type=template&id=388ef425&scoped=true"
import script from "./FileShareView.vue?vue&type=script&lang=js"
export * from "./FileShareView.vue?vue&type=script&lang=js"
import style0 from "./FileShareView.vue?vue&type=style&index=0&id=388ef425&prod&lang=scss&scoped=true"
import style1 from "./FileShareView.vue?vue&type=style&index=1&id=388ef425&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388ef425",
  null
  
)

export default component.exports